import { get, patch } from 'axios'
import { from } from 'rxjs'
const endpoint = '/company'

export const getLicenses = () => get(`${endpoint}/licenses`)

export const updateTerms = payload => from(patch(`${endpoint}/terms`, payload))

export default {
  getLicenses,
  updateTerms,
}
